import { Inject, Injectable, InjectionToken, Type } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { QuickDialogSetting } from 'src/app/core/interfaces/quickbuysell';

type QuickTradeDialogsModule = {
  QuickWizardComponent: Type<unknown>;
  QuickOrderDialogComponent: Type<unknown>;
};

export const QUICK_TRADE_DIALOGS_LOADER = new InjectionToken<
  () => Promise<QuickTradeDialogsModule>
>('QuickTradeDialogsLoader', {
  providedIn: 'root',
  factory: () => () => import('./quick-trade-dialogs.module')
});

@Injectable({ providedIn: 'root' })
export class QuickTradeDialogService {
  constructor(
    private dialog: MatDialog,
    private toastr: ToastrService,
    @Inject(QUICK_TRADE_DIALOGS_LOADER)
    private loadDialogs: () => Promise<QuickTradeDialogsModule>
  ) { }

  async openWizard(config: MatDialogConfig): Promise<void> {
    try {
      const { QuickWizardComponent } = await this.loadDialogs();
      this.dialog.open(QuickWizardComponent, config);
    } catch {
      this.toastr.error($localize`Unable to open quick trade right now. Please try again.`);
    }
  }

  async openOrder(data: QuickDialogSetting, config: Omit<MatDialogConfig, 'data'>): Promise<void> {
    try {
      const { QuickOrderDialogComponent } = await this.loadDialogs();
      this.dialog.open(QuickOrderDialogComponent, { ...config, data });
    } catch {
      this.toastr.error($localize`Unable to open quick trade right now. Please try again.`);
    }
  }
}
